module.exports = __webpack_public_path__ + "static/media/TN-Men-Outer-v2.0-OA.1549bde1.svg";